import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const newTravelFormSlice = createSlice({
    name: 'newTravelFormData',
    initialState,
    reducers: {
        setTravelFormData: (state, action) => {
            const { key, data } = action.payload;
            state[key] = data;
        },
        removeTravelFormData: (state, action) => {
            const key = action.payload;
            delete state[key];
        },
        resetTravelFormData: (state) => {
            return initialState;
        },
    },
});

export const {
    setTravelFormData,
    removeTravelFormData,
    resetTravelFormData,
} = newTravelFormSlice.actions;

export const selectTravelFormData = (state) => state.newTravelFormData;

export default newTravelFormSlice.reducer;